export default function initInputFile(): void {
    document.body.addEventListener("change", e => {
        const el = (e.target as HTMLElement).closest<HTMLInputElement>("input[type=\"file\"]");
        if (!el) {
            return;
        }

        const label = el.nextElementSibling;
        if (label && label.classList.contains("custom-file-label")) {
            label.innerHTML = el.value;
        }
    });
}
